import React from 'react'
import { ScreenSubMenuTP } from 'submodules/nerit-framework-ui/common/components/screen/layout-with-submenu/submenu/inner/ScreenSubMenuItemTP'
import { PrivateRouter } from 'app/routers/private/PrivateRouter'
import { ScreenContentQAQCAnomalyEvaluationHistory } from 'modules/reports/screens/screen-qaqc/content/ScreenContentQAQCAnomalyEvaluationHistory'
import { ScreenContentQAQCIonicBalanceHistory } from 'modules/reports/screens/screen-qaqc/content/ScreenContentQAQCIonicBalanceHistory'

export const QAQC_GENERAL = 'general'

export type ScreenQAQCViewTP = 'ionicBalanceHistory' | 'anomalyEvaluationHistory'

/**
 */
export const QAQCScreenUtils = {

    getSubMenuConfigs(): Array<ScreenSubMenuTP<ScreenQAQCViewTP>> {
        return [
            {
                key: QAQC_GENERAL,
                title: 'Histórico de Execuções',
                items: [
                    {
                        name: 'Balanço Iônico',
                        view: 'ionicBalanceHistory',
                        route: `${PrivateRouter.QAQC_IONIC_BALANCE_HISTORY}`,
                        content: <ScreenContentQAQCIonicBalanceHistory/>,
                    },
                    {
                        name: 'Avaliação de Anomalias',
                        view: 'anomalyEvaluationHistory',
                        route: `${PrivateRouter.QAQC_ANOMALY_EVALUATION_HISTORY}`,
                        content: <ScreenContentQAQCAnomalyEvaluationHistory/>,
                    },
                ],
                enabled: true
            }
        ]
    },

}
